module.exports = __webpack_public_path__ + "img/Christmas_Tree_Sword_demo.9fd1e0cd.gif";